export default {
  "content": "<path d=\"M22.598 6.75H19.5v-4.5A1.5 1.5 0 0018 .75H6a1.5 1.5 0 00-1.5 1.5v4.5H1.402A1.402 1.402 0 000 8.152v7.696a1.402 1.402 0 001.403 1.402H4.5v4.5a1.5 1.5 0 001.5 1.5h12a1.5 1.5 0 001.5-1.5v-4.5h3.098A1.402 1.402 0 0024 15.848V8.152a1.403 1.403 0 00-1.402-1.402zm-18.098 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm12 7.5h-9v-3h9v3zm0-13.5h-9v-3h9v3z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};